import { TopicTrees } from "@cappelendamm/catalogue/meilisearch/indexes.js";

export type FacetConfig = {
  attribute: string | TopicTrees;
  title: string;
  operator: "and" | "or";
  type: "refinement" | "hierarchy";
  queryParam?: string;
};

export const FACETS = {
  itemType: {
    attribute: "itemType",
    title: "Produkttype",
    operator: "or",
    type: "refinement",
    queryParam: "type",
  },
  "itemDetails.binding": {
    attribute: "itemDetails.binding",
    title: "Format",
    operator: "or",
    type: "refinement",
    queryParam: "format",
  },
  "itemDetails.language": {
    attribute: "itemDetails.language",
    title: "Språk",
    queryParam: "språk",
    operator: "and",
    type: "refinement",
  },
  "itemDetails.seriesName": {
    attribute: "itemDetails.seriesName",
    title: "Serienavn",
    operator: "and",
    type: "refinement",
    queryParam: "serie",
  },
  "itemDetails.literaryWorkName": {
    attribute: "itemDetails.literaryWorkName",
    title: "Verknavn",
    operator: "and",
    type: "refinement",
    queryParam: "verk",
  },
  authors: {
    attribute: "authors",
    title: "Forfatter",
    operator: "and",
    type: "refinement",
    queryParam: "forfatter",
  },
  aldersgrupper: {
    attribute: "aldersgrupper",
    title: "Aldersgruppe",
    operator: "or",
    type: "hierarchy",
    queryParam: "aldersgruppe",
  },
  utdanningsniv: {
    attribute: "utdanningsniv",
    title: "Utdanningsnivå",
    operator: "or",
    type: "hierarchy",
    queryParam: "utdanningsnivå",
  },
  lreplan: {
    attribute: "lreplan",
    title: "Læreplan",
    operator: "or",
    type: "hierarchy",
    queryParam: "læreplan",
  },
  kategorier: {
    attribute: "kategorier",
    title: "Kategorier",
    operator: "or",
    type: "hierarchy",
  },
} as const;

export const STANDARD_FACETS: FacetConfig[] = Object.values(FACETS);

export const HIERARCHY_SEPARATOR = "/" as const;

export const LOAD_MORE_BATCH_SIZE = 20 as const;
